import React, { Component, Fragment } from "react";
import GroupBarchart from "../../../../../d3Components/NewBarchart/GroupBarchart";
import SimpleTable from "../../../common/simpleTable";
import Legend from "../../../../../d3Components/legend";
import ContainerDimensions from "react-container-dimensions";

const Volatility = ({
  return_VS_volatility,
  typeName,
  benchmark_name,
  display_orig_portfolio,
  model_name,
}) => {
  let rowHeading2 = display_orig_portfolio
    ? "Benchmark *"
    : typeName
    ? typeName
    : "Benchmark";
  return (
    <Fragment>
      {return_VS_volatility.length > 0 ? (
        <div className="pb-5">
          <div>
            <div className="scrollX">
              <ContainerDimensions>
                {({ width }) => (
                  <Fragment>
                    {width > 0 ? (
                      <Fragment>
                        <Legend
                          height={30}
                          width={width}
                          legend1={
                            display_orig_portfolio
                              ? `IQCIO Model ${model_name ? "+" : ""}`
                              : "Portfolio"
                          }
                          legend2={rowHeading2}
                          legend3={
                            display_orig_portfolio ? "Original Portfolio" : null
                          }
                        />
                        <GroupBarchart
                          containerWidth={width}
                          height={300}
                          data={return_VS_volatility}
                          targetDiv="return_vs_vol"
                        />
                      </Fragment>
                    ) : null}
                  </Fragment>
                )}
              </ContainerDimensions>
            </div>
          </div>
          <SimpleTable
            rowHead1={
              display_orig_portfolio
                ? `IQCIO Model ${model_name ? "+" : ""}`
                : "Portfolio"
            }
            rowHead2={rowHeading2}
            rowHead3={display_orig_portfolio ? "Original Portfolio" : null}
            heading={return_VS_volatility.map((d, i) => {
              return <td key={i}>{d.metric_name}</td>;
            })}
            Row1={return_VS_volatility.map((d, i) => {
              return <td key={i}>{`${d.Portfolio} %`}</td>;
            })}
            Row2={return_VS_volatility.map((d, i) => {
              return <td key={i}>{`${d.Benchmark} %`}</td>;
            })}
            Row3={return_VS_volatility.map((d, i) => {
              return d["Original Portfolio"] ? (
                <td key={`${d}-${i}`}>{`${d["Original Portfolio"]}%`}</td>
              ) : null;
            })}
          />
          {display_orig_portfolio && benchmark_name ? (
            <div>
              <b>*</b> <small>{benchmark_name}</small>
            </div>
          ) : null}
          {model_name ? (
            <div>
              <small>
                <b>+</b>&nbsp;
                {model_name}
              </small>
            </div>
          ) : null}
        </div>
      ) : null}
    </Fragment>
  );
};
export default Volatility;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/Returns/section2/Volatility.jsx